import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import IconButton from '@mui/material/IconButton'
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined'
import {
  E_LEARNING_LEARNER_LOG_RESULT,
  MODULE_TYPE,
} from 'src/constants/eLearning'
import { isMediaWidthMoreThan } from 'src/utils/lib'
import { StyledFloatButton } from '../../Styled'
import { handleOpenScormReport, REPORT_COOLDOWN_MS } from './events'

const ScormReportButton = () => {
  const dispatch = useDispatch()
  const isNotSm = isMediaWidthMoreThan('sm')
  const [isCoolingDown, setCoolingDown] = useState(false)
  const { moduleType, result } = useSelector(
    (state) => ({
      moduleType: _.get(state.eLearningLearning.selectedLesson, 'moduleType'),
      result: _.get(state.eLearningLearning.selectedLesson, 'result'),
    }),
    shallowEqual,
  )

  useEffect(() => {
    if (!isCoolingDown) return
    const timeout = setTimeout(() => setCoolingDown(false), REPORT_COOLDOWN_MS)
    return () => clearTimeout(timeout)
  }, [isCoolingDown])

  if (
    moduleType !== MODULE_TYPE.SCORM ||
    result === E_LEARNING_LEARNER_LOG_RESULT.COMPLETE
  )
    return <></>

  const handleClick = () =>
    dispatch(handleOpenScormReport(() => setCoolingDown(true)))

  if (!isNotSm) {
    return (
      <IconButton
        size="small"
        aria-label="หน้าจอค้าง?"
        sx={{ position: 'absolute', top: 30, left: 180, zIndex: 3 }}
        disabled={isCoolingDown}
        onClick={handleClick}
      >
        <ReportProblemOutlined />
      </IconButton>
    )
  }

  return (
    <StyledFloatButton
      size="small"
      sx={{ left: 190, color: 'text.secondary' }}
      startIcon={<ReportProblemOutlined />}
      disabled={isCoolingDown}
      onClick={handleClick}
    >
      หน้าจอค้าง?
    </StyledFloatButton>
  )
}

export default ScormReportButton
